import { render, staticRenderFns } from "./loadingBtn.vue?vue&type=template&id=3e5bfdd0&"
import script from "./loadingBtn.vue?vue&type=script&lang=js&"
export * from "./loadingBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5bfdd0')) {
      api.createRecord('3e5bfdd0', component.options)
    } else {
      api.reload('3e5bfdd0', component.options)
    }
    module.hot.accept("./loadingBtn.vue?vue&type=template&id=3e5bfdd0&", function () {
      api.rerender('3e5bfdd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/btns/loadingBtn.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/btns/loadingBtn.vue
// module id = ks2E
// module chunks = 0